// Slice to user Info
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  user: true,
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser: (state, action) => {
      state.user = true;
    },
  },
});

export const { setUser } = userSlice.actions;

export default userSlice.reducer;
